<template>
  <div>
    <slot></slot>
    <SuccessSnackbar :message="successMessage" v-model="successSnackbar" />
    <ErrorSnackbar :message="errorMessage" v-model="errorSnackbar" />
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, provide, ref } from "vue"
import SuccessSnackbar from "app/ui-primitives/snackbars/SuccessSnackbar.vue"
import ErrorSnackbar from "app/ui-primitives/snackbars/ErrorSnackbar.vue"

const SNACKBAR_KEY = Symbol("snackbar")
type SnackbarConcern = {
  showSuccess: (message: string) => void
  showError: (message: string) => void
}

export const useSnackbar = () => {
  const snackbarConcern = inject<SnackbarConcern>(SNACKBAR_KEY, null)
  if (!snackbarConcern) {
    throw new Error(
      "useSnackbar must be used within a SnackbarProvider. Did you forget to add the provider at a root component?"
    )
  }
  return snackbarConcern
}

export default defineComponent({
  name: "SnackbarProvider",
  components: { ErrorSnackbar, SuccessSnackbar },
  setup() {
    const successSnackbar = ref(false)
    const successMessage = ref("")

    const errorSnackbar = ref(false)
    const errorMessage = ref("")

    const showSuccess = (message: string) => {
      successMessage.value = message
      successSnackbar.value = true
    }

    const showError = (message: string) => {
      errorMessage.value = message
      errorSnackbar.value = true
    }

    provide(SNACKBAR_KEY, { showSuccess, showError })

    return { successSnackbar, successMessage, errorSnackbar, errorMessage }
  },
})
</script>
